import { HomeProcessingRule } from '../interfaces';

export const homeUserIconRule: HomeProcessingRule = context => ({
    ...context,
    icon: context.isLoggedIn ? 'user-check' : 'user',
});
